export default __webpack_public_path__ + "static/media/tracer-unit.1e2ecbe8.svg";